import axios from 'axios';

import BaseService from '../baseService';

export default class TeacherService extends BaseService {

  async getMyCourses() {

    const USER_ID = localStorage.getItem('user')
    const response = await axios.get(process.env.VUE_APP_API + '/courses/?id=' + USER_ID);
    return response;
  }
  async getProfile() {
    console.log('1fofofo');
    const USER_ID = localStorage.getItem('user')
    const response = await axios.get(process.env.VUE_APP_API + `/profile/${USER_ID}`);

    return response;
  }

  async update(data) {
    const URI = `/user/${data.id}`;
    const response = await axios.patch(process.env.VUE_APP_API + URI, data)
    return response
  }
  async createBank(data) {
    const URI = `/bank`;
    const response = await axios.post(process.env.VUE_APP_API + URI, data)
    return response
  }
  async updateBank(data, id) {
    const URI = `/bank/${id}`;
    const response = await axios.patch(process.env.VUE_APP_API + URI, data)
    return response
  }

  async getAllTeachers(){
    const URI = '/user/allTeachers'
    const response = await axios.get(process.env.VUE_APP_API + URI);
    return response.data;
  }
}